import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Salut ! Je m’appelle <span className="purple">Valentin CRETON</span>{" "}
            et j’habite sur la <span className="purple">côte basque</span>.
            <br />
            Actuellement, je suis{" "}
            <span className="purple">administrateur systèmes et réseaux</span> chez{" "}
            <span className="purple">ADITU</span>.
            <br />
            <br />
            En dehors du travail, j’aime faire ceci :
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Jouer aux jeux vidéo 🎮
            </li>
            <li className="about-activity">
              <ImPointRight /> Découvrir de nouvelles choses 🔍
            </li>
            <li className="about-activity">
              <ImPointRight /> Voyager 🌍
            </li>
            <li className="about-activity">
              <ImPointRight /> Faire du bénévolat (WorldSkills) 🤝
            </li>
          </ul>
	</blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
